import {query} from "sinao-corejs";
import i18n from "@/i18n";
import Vue from "vue";

const contacts = {
    state: {
        contacts: [],
        thirdAccount: null,
        thirdAccount_null: {
            location: null,
            name: null,
            address: null,
            type: null,
            id: null,
            contactestablishment_contact_id: null
        },
        isThirdAccountGlobal: false,
        contactInfos: null,
        editableContact: {
            type: null, // person or organization,
            name: "",
            firstname: "",
            billing_name: null,
            email:"",
            phone: "",
            legal_form: "",
            vat: "",
            country: "FR",
            civility: "M",
            national_id: "",
            lastname: "",
        },
        editableEstablishment: {
            id: null,
            place: null,
            email: null,
            phone: null
        },
        editableEstablishmentContact: {
            email: null,
            id: null,
            job: null,
            name: null,
            phone: null,
            establishment: {
                id: null
            }
        },
        loadingContact: false,
        googleAutoCompleteKey: 0,
        renderGA: false
    },
    mutations: {
        isThirdAccountGlobal(state, payload) {
            state.isThirdAccountGlobal = payload;
        },
        contacts(state, payload) {
            state.contacts = payload;
        },
        "thirdAccount"(state, payload) {
            if(payload?.billing_name && payload?.billing_name.length > 0) {
                payload.name = payload.billing_name
            }

            state.thirdAccount = Object.assign({}, {...payload});
        },
        renderGA(state, payload) {
            state.renderGA = payload;
        },
        contactInfos(state, payload) {
            if(payload?.billing_name && payload?.billing_name.length > 0) {
                payload.name = payload.billing_name
            }
            // add civility in person name
            /* => seems provided by response
            if (payload?.type === "person") {
                let fullName = payload.civility?.length ? (payload.civility) : "";
                if (payload.firstname.length > 0) fullName += " " + payload.firstname;
                if (payload.lastname.length > 0) fullName += " " + payload.lastname;
                payload.name = fullName;
            }
            */
            state.contactInfos = Object.assign({}, {...payload});
        },
        updateContactInfosEstablishment(state, { establishment, target }) {
            if (state[target].establishments.length === 0) {
                state[target].establishments = [establishment];
            } else {
                const establishment_index = state[target].establishments.findIndex(e => e.id === establishment.id);
                if (establishment_index >= 0) {
                    state[target].establishments.splice(establishment_index, 1, establishment);
                }
            }
        },
        updateContactInfosEstablishmentPlace(state, { establishment, target }) {
            const _contactUpdated = JSON.parse(
                JSON.stringify(state[target]),
            );
            const _establishment_index = _contactUpdated.establishments.findIndex(e => e.id === establishment.id);
            if (_establishment_index >= 0) {
                _contactUpdated.establishments[_establishment_index].place = Object.assign({}, {...establishment.place});
            } else if (establishment.id) { // establishment has just been created
                _contactUpdated.establishments.push(establishment)
            }

            // update contactInfos address properties if edited place was selected establishment place
            if (establishment.id === _contactUpdated.establishment_id) {
                _contactUpdated.address = _contactUpdated.establishments[_establishment_index].place ? _contactUpdated.establishments[_establishment_index].place.exported_address : "";
                _contactUpdated.location = _contactUpdated.establishments[_establishment_index].place ?
                    ((_contactUpdated.establishments[_establishment_index].place.postal_code ?? "") + " " + (_contactUpdated.establishments[_establishment_index].place.locality ?? "") + " " + (_contactUpdated.establishments[_establishment_index].place.country ?? "")).trim()
                    : "";
            }

            state[target] = Object.assign({}, {..._contactUpdated});
        },
        updateContactInfosEstablishmentContact(state, { target, establishment, contact }) {
            const _contactInfos = JSON.parse(
                JSON.stringify(state[target]),
            );
            const _establishments = [..._contactInfos.establishments];
            const _establishment_index = _establishments.findIndex(e => e.id === establishment.id);
            if (_establishment_index >= 0) {
                const _establishment_contact_index = _establishments[_establishment_index].contacts.findIndex(c => c.id === contact.id);
                if (_establishment_contact_index >= 0) {
                    _establishments[_establishment_index].contacts[_establishment_contact_index] = Object.assign({}, {...contact});
                }
            }
            if (contact.id === _contactInfos.establishment_contact_id) {
                _contactInfos.establishment_contact_id = contact.id;
                _contactInfos.email = contact.email
                _contactInfos.details = contact.name + (contact.job?.length ? " " : "") + (contact.job?.length ? contact.job : "");
            }
            state[target] = Object.assign({}, {..._contactInfos});
        },
        editableEstablishment(state, payload) {
            state.editableEstablishment = Object.assign({}, JSON.parse(
                JSON.stringify(payload),
            ));
        },
        editableEstablishmentContact(state, payload) {
            state.editableEstablishmentContact = Object.assign({}, JSON.parse(
                JSON.stringify(payload),
            ));
        },
        loadingContact(state, payload) {
            state.loadingContact = payload
        },
        resetEditableEstablishment(state) {
            state.editableEstablishment = {
                id: null,
                is_delivery: false,
                place: null,
                email: null,
                phone: null
            };
        },
        googleAutoCompleteKey(state, payload) {
            state.googleAutoCompleteKey = payload;
        },
        setEditableContactType(state, payload) {
            state.editableContact.type = payload;
        },
        editableContact(state, payload) {
            state.editableContact = Object.assign({}, payload);
        },
        resetEditableContact(state) {
            state.editableContact = {
                type: null, // person or organization,
                name: "",
                firstname: "",
                lastname: "",
                billing_name: null,
                email:"",
                phone: "",
                legal_form: "",
                vat: "",
                country: "FR",
                national_id: "",
                civility: "M"
            };
        },
        updateContactInfos(state, { data, target }) { // update contactInfos or ThirdAccount as target parameter
            const newContactInfos = {
                address: data.establishments?.[0]?.place?.exported_address ?? "",
                billing_name: data.billing_name ?? data.name ?? "",
                code_naf: data.code_naf ?? "",
                code_se: data.code_se ?? null,
                country_iso2: data.country_iso2 ?? "FR",
                created_at: data.created_at,
                deleted_at:null,
                details: "",
                discount: data.relationship?.discount ?? null,
                dissolution_date: data.dissolution_date ?? null,
                duns: data.duns ?? null,
                email: data.email ?? null,
                establishment_contact_id: data.establishment_contact_id ?? 0,
                establishment_id: data.establishment_id ?? null,
                establishments: data.establishments ?? [],
                founding_date: data.founding_date ?? null,
                founding_location: data.founding_location ?? null,
                greffe: data.greffe ?? null,
                id: data.id,
                image: data.image ?? null,
                legal_form: data.legal_form ?? null,
                location: data.establishments?.[0]?.place?.location ?? ((data.establishments?.[0]?.place?.postal_code ?? "") + " " +  (data.establishments?.[0]?.place?.locality ?? "") + " - " + (data.establishments?.[0]?.place?.country ?? "")) ?? "",
                metadata: data.metadata ?? null,
                modal: false,
                name: data.name ?? "",
                national_id: data.national_id ?? null,
                number_of_employees: data.number_of_employees ?? null,
                paymentDelayClient: data.relationship?.payment_period	?? null,
                paymentMethodsClient: data.relationship?.payment_methods ?? null,
                rcs: data.rcs ?? null,
                sirene_data: data.sirene_data ?? null,
                slogan: data.slogan ?? null,
                suggest: data.billing_name ?? data.name ?? "",
                tags: data.relationship?.tags ?? [],
                tax_id: data.tax_id ?? null,
                type: data.type ?? "organization",
                vat_id: data.vat_id ?? null,
                vat_system:null
            }
            state[target] = Object.assign({}, newContactInfos);
        }
    },
    getters: {},
    actions: {
        // TODO deprecated ?
        /*async createOrUpdateEstablishmentContact({ rootState, state, getters, commit }) {
            try {
                const _updated_establishment = await query({
                    operationId: `app.contacts.establishments.update`,
                    token: rootState.token,
                    params: {
                        appId: rootState.app.id,
                        id: state.contactInfos.establishment_id,
                        "expand[0]": "contacts"
                    },
                    data: {
                        contacts: [{
                            id: state.contactInfos.establishment_contact_id > 0 ? state.contactInfos.establishment_contact_id : null,
                            name: state.contactInfos.details ?? "",
                            email: state.contactInfos.email ?? ""
                        }]
                    }
                });
                // set state.contactInfos.establishment_contact_id
                if (state.contactInfos.establishment_contact_id === 0) {
                    const _contactInfos = JSON.parse(
                        JSON.stringify(state.contactInfos),
                    );
                    const _updated_establishment_index = _contactInfos.establishments.findIndex(e => e.id === _updated_establishment.id);
                    if (_updated_establishment_index >= 0) {
                        _contactInfos.establishments.splice(_updated_establishment_index, 1, _updated_establishment);
                    }

                    const _created_estaContact = _updated_establishment.contacts.find(new_ec => !getters.contactInfos_establishments_contacts.find(old_ec => old_ec.id === new_ec.id));
                    if (_created_estaContact !== undefined) {
                        _contactInfos.establishment_contact_id =_created_estaContact.id;
                    }
                    commit('contactInfos', Object.assign({}, {..._contactInfos} ))
                }
            } catch (error) {
                this._vm.$bvToast.toast( i18n.t("Une erreur est survenue lors de la mise à jour du contact"), {
                    title: i18n.t("Erreur"),
                    variant: "danger",
                    solid: true
                });
            }
        },
        async createEstablishment({ commit, rootState, state }) {
            // send request to create new Establishment
            try {
                const _updated_contactInfo = await query({
                    operationId: state.contactInfos.type === "organization" ? "app.contacts.organizations.update" : "app.contacts.persons.update",
                    token: rootState.token,
                    params: {
                        'establishments[0][]]': '',
                        'expand[]': 'establishments',
                        'expand[1]': 'establishments.contacts',
                        appId: rootState.app.id,
                        id: state.contactInfos.id
                    }
                });
                // get the id of the newly created establishment
                const _created_establishment = _updated_contactInfo.establishments.find(new_e => !state.contactInfos.establishments.find(old_e => old_e.id === new_e.id))

                // if success, set new establishment place
                if (_created_establishment !== undefined) {
                    const street_number = null;
                    const route = state.contactInfos.address;
                    const route2 = null;
                    let postal_code = null;
                    let locality = null;
                    let country = null;

                    if (/ - /.test(state.contactInfos.location)) { // there is a country in location
                        const location_parts = state.contactInfos.location.trim().split(" - ");

                        // country
                        if (location_parts.length > 1)
                            country = location_parts[1];

                        postal_code = location_parts[0].match(/\d+/)[0];
                        locality = location_parts[0].replace(postal_code, "").trim();
                    } else { // there is no country in location
                        postal_code = state.contactInfos.location.match(/\d+/)[0];
                        locality = state.contactInfos.location.replace(postal_code, "").trim();
                    }


                    const _updated_establishment = await query({
                        operationId: `app.contacts.establishments.update`,
                        token: rootState.token,
                        params: {
                            appId: rootState.app.id,
                            id: _created_establishment.id
                        },
                        data: {
                            place: {
                                street_number: street_number,
                                route: route,
                                route2: route2,
                                postal_code: postal_code,
                                locality: locality,
                                country: country
                            }
                        }
                    });

                    // update contactInfos.establishments
                    const _contactInfos = JSON.parse(
                        JSON.stringify(state.contactInfos),
                    );
                    if (_updated_establishment.contacts === undefined) {
                        _updated_establishment.contacts = [];
                    }
                    _contactInfos.establishments.push(_updated_establishment)
                    _contactInfos.establishment_id =  _created_establishment.id;
                    commit('contactInfos', Object.assign({}, {..._contactInfos} ));
                } else {
                    throw new Error('id du nouvel établissement non détecté');
                }

            } catch (error) {
                this._vm.$bvToast.toast(i18n.t("Une erreur est survenue lors de la création du nouvel établissement"), {
                    title: i18n.t("Erreur"),
                    variant: "danger",
                    solid: true
                });
                console.log("error create establishment ", error);
            }
        },*/
        async createEstablishment({ commit, rootState, state }, target) {
            // send request to create new Establishment
            try {
                const _updated_contactInfo = await query({
                    operationId: state[target].type === "organization" ? "app.contacts.organizations.update" : "app.contacts.persons.update",
                    token: rootState.token,
                    params: {
                        'establishments[0][]]': '',
                        'expand[]': 'establishments',
                        'expand[1]': 'establishments.contacts',
                        appId: rootState.app.id,
                        id: state[target].id
                    }
                });
                // get the id of the newly created establishment
                const _created_establishment = _updated_contactInfo.establishments.find(new_e => !state[target].establishments.find(old_e => old_e.id === new_e.id))

                if (_created_establishment !== undefined) {
                    // update contactInfos.establishments
                    const _contactInfos = JSON.parse(
                        JSON.stringify(state[target]),
                    );

                    _contactInfos.establishments.push(_created_establishment);
                    _contactInfos.establishment_id = _created_establishment.id;
                    commit(target, _contactInfos);

                    return _created_establishment;
                } else {
                    throw new Error('id du nouvel établissement non détecté');
                }

            } catch (error) {
                this._vm.$bvToast.toast(i18n.t("Une erreur est survenue lors de la création du nouvel établissement"), {
                    title: i18n.t("Erreur"),
                    variant: "danger",
                    solid: true
                });
                console.log("error create establishment ", error);
            }
        },
        async updateOrCreateEstablishmentPlaceFromEditableEstablishment({ commit, rootState, state, dispatch }, { target }) {
            commit('loadingContact', true);
            // First: create Establishment if not exists
            if (state.editableEstablishment.id === 0) {
                const _updated_contactInfo = await query({
                    operationId: state[target].type === "organization" ? "app.contacts.organizations.update" : "app.contacts.persons.update",
                    token: rootState.token,
                    params: {
                        'establishments[0][]]': '',
                        'expand[]': 'establishments',
                        'expand[1]': 'establishments.contacts',
                        appId: rootState.app.id,
                        id: state[target].id
                    }
                });
                // get the id of the newly created establishment
                const _created_establishment = _updated_contactInfo.establishments.find(new_e => !state[target].establishments.find(old_e => old_e.id === new_e.id));
                if (_created_establishment !== undefined) {
                    // assign this new id to editableEstablishment
                    const _editableEstablishment = JSON.parse(
                        JSON.stringify(state.editableEstablishment),
                    );
                    _editableEstablishment.id = _created_establishment.id;
                    commit("editableEstablishment", _editableEstablishment);
                    // assign to target
                    const _target = JSON.parse(
                        JSON.stringify(state[target]),
                    );
                    // update target establishment_id only if not a delivery establishment
					if (!_editableEstablishment.is_delivery) {
                    	_target.establishment_id = _created_establishment.id;
					}
                    // add this new establishment to target establishments
                    _target.establishments.push(_created_establishment);
                    commit(target, _target);
                }
            }
            // Then: call update establishment place in target establishments
            Vue.nextTick(() => {
                if (state.editableEstablishment.id) {
                    dispatch("updateEstablishmentPlace", { target: target });
                }
            });

        },
        async updateEstablishmentPlace({ commit, rootState, state }, { target }) {
            commit('loadingContact', true);
            try {
                const updatedEstablishment = await query({
                    operationId: `app.contacts.establishments.update`,
                    token: rootState.token,
                    params: {
                        appId: rootState.app.id,
                        id: state.editableEstablishment.id,
                        "expand[0]": "contacts"
                    },
                    data: {
                        place: {
                            street_number: state.editableEstablishment.place.street_number,
                            route: state.editableEstablishment.place.route,
                            route2: state.editableEstablishment.place.route2,
                            postal_code: state.editableEstablishment.place.postal_code,
                            locality: state.editableEstablishment.place.locality,
                            country: state.editableEstablishment.place.country,
                        }
                    }
                });
                // update contact_infos
                commit("updateContactInfosEstablishmentPlace", { establishment:  updatedEstablishment, target: target });
                // update contacts
                const _contacts = state.contacts.map((contact) => {
                    const index = contact.establishments.findIndex(e => e.id === updatedEstablishment.id);
                    if (index >= 0) {
                        contact.establishments.splice(index,1, updatedEstablishment);
                    }
                    return contact;
                 });
                commit("contacts", _contacts);
                commit("loadingContact", false);
                commit("showEditAddressModal", false);
            } catch (error) {
                this._vm.$bvToast.toast( i18n.t("Une erreur est survenue lors de la mise à jour de adresse"), {
                    title: i18n.t("Erreur"),
                    variant: "danger",
                    solid: true
                });
                console.error(error);
            }
            commit('loadingContact', false);
        }
    }
};

export default contacts;
